import type { Transition, Variants } from "framer-motion";

/** Shared motion tokens: one easing family and a small set of durations used across the site. */
export const ease = {
  premium: [0.22, 1, 0.36, 1] as [number, number, number, number],
  inOut: [0.65, 0, 0.35, 1] as [number, number, number, number],
};

export const duration = {
  fast: 0.2,
  base: 0.4,
  slow: 0.7,
};

export const spring = {
  snappy: { type: "spring", stiffness: 420, damping: 30 } as Transition,
  bouncy: { type: "spring", stiffness: 520, damping: 18 } as Transition,
  soft: { type: "spring", stiffness: 260, damping: 28 } as Transition,
};

/** Route transition: fade + slight rise in, quick fade out. */
export const pageVariants: Variants = {
  initial: { opacity: 0, y: 12 },
  enter: { opacity: 1, y: 0, transition: { duration: duration.base, ease: ease.premium } },
  exit: { opacity: 0, transition: { duration: 0.15, ease: ease.inOut } },
};

/** Scroll reveals. `custom` is an optional delay in seconds. */
export const revealVariants: Variants = {
  hidden: ({ y = 24, x = 0 }: { y?: number; x?: number } = {}) => ({ opacity: 0, y, x }),
  visible: ({ delay = 0 }: { delay?: number } = {}) => ({
    opacity: 1,
    y: 0,
    x: 0,
    transition: { duration: duration.slow, ease: ease.premium, delay },
  }),
};

export const staggerContainer = (stagger = 0.08, delayChildren = 0): Variants => ({
  hidden: {},
  visible: { transition: { staggerChildren: stagger, delayChildren } },
});

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: duration.slow, ease: ease.premium } },
};

/** Modal / drawer / dropdown surfaces. */
export const backdropVariants: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: duration.fast } },
  exit: { opacity: 0, transition: { duration: duration.fast } },
};

export const modalVariants: Variants = {
  hidden: { opacity: 0, scale: 0.96, y: 12 },
  visible: { opacity: 1, scale: 1, y: 0, transition: spring.snappy },
  exit: { opacity: 0, scale: 0.97, y: 8, transition: { duration: 0.15, ease: ease.inOut } },
};
